import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import messages from './messages';
import styles from './PasswordAccountCreation.module.scss';
import { setIsAlmostDone, setIsUserNotConfirmed, setUnverifiedEmail } from '../../../slices/accounts';
import AuthService from '../../../services/cognito/auth';
import LinkButton from '../../common/LinkButton';

const AccountCreationError = ({ accountCreationError, customerEmail = null}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const [isResend, setIsResend] = useState(false);

  const handleError = (error, emailAddress) => {
    if (error.name === 'UserNotConfirmedException') {
      dispatch(setUnverifiedEmail({ unverifiedEmail: emailAddress }));
      dispatch(setIsUserNotConfirmed({ isUserNotConfirmed: true }));
      dispatch(setIsAlmostDone({ isAlmostDone: false }));
    } else {
      dispatch(setIsUserNotConfirmed({ isUserNotConfirmed: false }));
      dispatch(setIsAlmostDone({ isAlmostDone: false }));
    }
  };

  const resendVerificationEmail = async (username) => {
    try {
      const response = await AuthService.resendConfirmationCode({ username });
      if (response?.CodeDeliveryDetails?.Destination) {
        dispatch(setIsUserNotConfirmed({ isUserNotConfirmed: false }));
        dispatch(setIsAlmostDone({ isAlmostDone: true }));
        setIsResend(true);
      }
    } catch (error) {
      handleError(error, username);
    }
  };

  return (
    <>
      <div className={styles['email-exists-error']}>
        {accountCreationError === 'UserNotConfirmedException' && (
        <>
          { !isResend ? (
            <>
              <span className={styles['email-not-verifield-title']}>
                {formatMessage(messages.emailNotVerifiedErrorTitle)}
              </span>
              <span className={styles['text-spacing-right']}>{formatMessage(messages.emailNotVerifiedErrorPt1)}</span>
              <span className={styles['email-not-verified-email']}>{customerEmail}</span>
              <span className={styles['text-spacing-right']}>{`. ${formatMessage(messages.emailNotVerifiedErrorPt2)}`}</span>
              <span className={styles['text-spacing-right']}>{formatMessage(messages.resendVerificationEmailPt1)}</span>
              <span className={styles['resend-email-click-here']}>
                <LinkButton
                  id="resendButton"
                  isError
                  isBold
                  onClick={() => resendVerificationEmail(customerEmail)}
                  linkText={formatMessage(messages.resendVerificationEmailPt2)}
                />
              </span>
              <span>{formatMessage(messages.resendVerificationEmailPt3)}</span>
            </>
          ) : (
            <>
              <span className={styles['text-purple']}>{formatMessage(messages.resendVerifyMessagePt1)}</span>
              <span className={styles['unverified-email']}>{customerEmail}</span>
              <span className={styles['text-purple']}>{`. ${formatMessage(messages.resendVerifyMessagePt2)} `}</span>
            </>
          )}
        </>
        )}
      </div>
    </>
  );
};

AccountCreationError.propTypes = {
  accountCreationError: PropTypes.string.isRequired,
  customerEmail: PropTypes.string,
};

export default AccountCreationError;
